var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"d-flex align-items-center"},[_c('p',{staticClass:"mb-0 mr-2 text-white"},[_vm._v("Desenvolvido por")]),_c('a',{attrs:{"href":"https://lais.huol.ufrn.br/","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/logo-lais-white.svg"),"alt":""}})])])
}]

export { render, staticRenderFns }